import { isBefore, isSameDay } from 'date-fns'
import {
  currentTzDate,
  parseLocalDatetimeStringToZonedDate,
} from 'Data/format.js'

export function shouldShow({ state, start, location: { time_zone_id } }) {
  // Show No Show only for today's appointment and whose start time is in the past
  let currentDate = currentTzDate(time_zone_id)
  let appointmentDate = parseLocalDatetimeStringToZonedDate(start, time_zone_id)
  let isToday = isSameDay(currentDate, appointmentDate)
  let isBeforeNow = isBefore(appointmentDate, currentDate)

  return state === 'SCHEDULED' && isToday && isBeforeNow
}
